import { useEffect, useRef } from "react";
import { calc, openWebView } from "../../js/chips-common";
import Lottie from "react-lottie";
import eventPage from "../assets/description.json";

export default function LandingButton(props) {
  const dev = props.dev;
  const domain = (dev || "").includes("dev")
    ? `https://api.${dev}.chips.today`
    : "https://api.chips.today";

  useEffect(() => {}, []);
  return (
    <div
      className={"active-only-alpha"}
      style={{
        position: "relative",
        marginTop: calc(312),
        // zIndex: 5,
        width: "100vw",
      }}
      onClick={() => {
        const landingUrl = `${domain}/api/v1/posts/${
          (dev || "").includes("dev") ? "44" : "69"
        }`;
        openWebView(landingUrl);
      }}
    >
      <div
        style={{
          width: "100%",
          objectFit: "contain",
        }}
      >
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData: eventPage,
            rendererSettings: {
              preserveAspectRatio: "xMinYMin meet",
            },
            // touch disable
            isClickToPauseDisabled: false,
          }}
          isClickToPauseDisabled={true}
          style={{
            // position: "absolute",
            width: calc(360),
          }}
        />
      </div>
    </div>
  );
}
